// extracted by mini-css-extract-plugin
export default {"scaffold":"l_header_d_scaffold__hx7mC","f20w700white":"l_header_d_f20w700white__EOEXR"};